export const selectbutton = {
  root: {
    borderRadius: '1rem',
  },
  css: ({ dt }: any) => `
    .p-selectbutton {
      background-color: white;

      > .p-togglebutton {
        padding: 0.1rem;
        border-radius: 0rem;

        > .p-togglebutton-content {
          border-radius: 0.9rem !important;
        }
      }

      .p-togglebutton-checked {
        // color: var(--p-accent-500) !important;
      }
    }
  `,
};
